<template>
	<component
		:is="isInternalLink ? AbsoluteInternalLink : 'a'"
		:href="link.cached_url"
		:target="link.target"
		class="btn"
	>
		<slot />
	</component>
</template>

<script setup lang="ts">
	import type {MultilinkStoryblok} from '~/storyblok/types';

	type Props = {
		link: MultilinkStoryblok
	};

	const props = defineProps<Props>();

	const AbsoluteInternalLink = resolveComponent('AbsoluteInternalLink');

	const isInternalLink = computed(() => props.link.linktype === 'story');
</script>
